module.exports = __webpack_public_path__ + "img/street.b40cbb1e.svg";